<template>
    <div class="steps-footer d-flex align-items-center p-3 p-lg-5 bg-white border-radius-bottom justify-content-center" :class="{ 'align-last-stp' : getActiveStep === lastStepID}">
        <div class="d-flex flex-lg-grow-1 flex-grow-0 me-3">
            <a href="#" class="d-none d-xl-block btn final-step-button me-xl-4 btn-outline-secondary end" v-if="getActiveStep > 0 && getActiveStep < lastStepID -1" @click="MoveBack">
                {{ text.back }}
            </a>

            <a href="#" class="d-flex d-xl-none btn final-step-button me-xl-4 btn-outline-secondary end px-md-7 px-6 icon-circle" v-if="getActiveStep > 0 && getActiveStep < lastStepID -1" @click="MoveBack">
                <div class="icon-wrapper border-radius-main no-overflow ">
                    <svg class="icon-base">
                        <use xlink:href="/dist/icons/solid.svg#arrow-left">
                        </use>
                    </svg>
                </div>
            </a>
        </div>

        <div class="daten-btn desk d-none d-lg-flex justify-content-lg-center">
            <a href="#" class="final-step-button me-4 data text-s" @click="openModal">
                {{ text.eTerminDataPrivacy }}
            </a>
        </div>

        <a href="#" class="btn final-step-button me-xl-4 events px-md-7 px-4 btn-primary" v-if="getActiveStep === lastStepID - 2 && loading.status !== true  && !error" @click="ManageAppointement">
            {{ text.book }}
        </a>
        <a href="#" class="btn final-step-button me-xl-4 events end px-md-7 px-6 flex-grow-1 flex-lg-grow-0" id="next-btn" :class="{ 'btn-disabled' : steps[getActiveStep].validation.status !== 1, 'btn-primary' : steps[getActiveStep].validation.status===1  }" v-if="getActiveStep < lastStepID -2 && loading.status!==true && !error" @click="MoveNext">
            {{ text.next }}
        </a>
        <a href="#" class="btn btn-disabled final-step-button me-xl-4 events end px-md-7 px-6" v-if="loading.status!==true && error===true"  @click="retry">
            {{ text.retry }}
        </a>
        <a href="#" class="btn btn-primary final-step-button me-xl-4 events end px-md-7 px-6" v-if="!error && getActiveStep === lastStepID - 1 && this.type === `map`" @click="closeApp">
            {{ text.closeForm }}
        </a>

        <Spinner :message ="loading.message" v-if="loading.status" class="mt-4" />

        <div class="calendar-links d-flex flex-lg-row flex-column" v-if="getActiveStep === lastStepID">
            <a class="export-download button-secondary btn btn-primary final-step-button me-lg-4" :href="eterminCalExport">
                <font-awesome-icon class="me-2" icon="calendar-week"/>Download (.ICS)
            </a>

            <add-to-calendar :title="calenderTitle" :location="fullAddress" :start="appointement.start|obdate" :end="appointement.end|obdate" :details="calenderDescription" inline-template>
                <div class="d-flex flex-lg-row flex-column">
                    <google-calendar id="google-calendar" class="btn btn-primary final-step-button mt-2 mt-lg-0 me-lg-4">
                        <font-awesome-icon class="mr-2" icon="calendar-week"/>Google Calendar
                    </google-calendar>
                    <microsoft-calendar id="microsoft-calendar" class="btn btn-primary final-step-button mt-2 mt-lg-0 mr-lg-4 end">
                        <font-awesome-icon class="mr-2" icon="calendar-week"/>Microsoft Live-Calendar
                    </microsoft-calendar>
                </div>
            </add-to-calendar>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import AddToCalendar from 'vue-add-to-calendar'
import Spinner from 'vue-simple-spinner'
import ServiceDrupal from '@/services/ServiceDrupal.js'

moment.locale('de')

export default {
    name: 'steps-footer',
    props: {
        appointement: {
            type: Object,
            required: true
        },
        fields: {
            type: Object,
            required: true
        },
        format: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false
        }
    },
    data () {
        return {
            error: false,
            text: {
                back: Drupal.t('Back'),
                book: Drupal.t('Book an appointment'),
                next: Drupal.t('Next'),
                calendar: Drupal.t('Calendar'),
                retry: Drupal.t('Retry'),
                eTerminDataPrivacy: Drupal.t('Timify data privacy policy'),
                closeForm: Drupal.t('Back to website')
            }
        }
    },
    components: {
        AddToCalendar,
        Spinner
    },
    filters: {
        obdate: function (value) {
            return new Date(moment(value))
        }
    },
    watch: {
        createdApp: {
            deep: true,
            handler (createdApp) {
                if (createdApp === true) {
                    let currentIndexActive = Number(this.getActiveStep)
                    let nextActive = currentIndexActive + 1
                    this.$store.dispatch('etermin/updateSteps', nextActive)
                }
            }
        },
        notifications: {
            deep: true,
            handler (notifications) {
                let errorNotif = notifications.filter(notification => notification.type === 'error')
                if (errorNotif.length > 0) {
                    if (notifications[0].direct !== undefined) {
                        this.appointement.date = null
                        this.appointement.time = null
                        if(this.reservation.id!==null){
                            this.$store.dispatch('etermin/deleteReservation', {
                                "store": this.selectedStore,
                                "calenderid":this.appointement.calenderid,
                                "reservation_id": this.reservation.id,
                                "secret": this.reservation.secret,
                                "reason" : "",
                                "cancellation" : 0
                            })
                        }
                        if(notifications[0].sending.source==="post/appointment" || notifications[0].sending.source ==="delete/reservations"){
                            this.$store.dispatch('etermin/updateSteps', 1)
                        }
                        else{
                            this.$store.dispatch('etermin/updateSteps', this.getActiveStep === 0 ? 0 : (this.getActiveStep - 1))
                        }
                        this.error = false
                    } else {
                        this.error = true
                    }
                } else {
                    this.error = false
                }
                if (notifications.length > 0) {
                    let options = {
                        container: '.etermin-wrapper',
                        easing: 'ease-in',
                        lazy: false,
                        offset: -80,
                        force: true,
                        cancelable: true,
                        x: false,
                        y: true
                    }
                    this.$scrollTo('.notification-container', 500, options)
                }
            }
        },
        reservation: {
            deep: true,
            handler (data) {
                if(data.id!=null){
                    this.createAppointement(data.id,data.secret);
                }
            }
        }
    },
    computed: {
        calenderTitle: function () {
            return Drupal.t('Your appointment on @date at @time.', {'date': this.getDate(this.appointement.start), 'time': this.getTime(this.appointement.start)})
        },
        calenderDescription: function () {
            return Drupal.t('If you need to reschedule, or cancel, please feel free to call us at @phone.', {'@phone': this.selectedStore.phone})
        },
        eterminCalExport: function () {
            return 'https://www.etermin.net/vcalendar.aspx?appID=' + this.appointement.id
        },
        fullAddress: function () {
            return this.selectedStore.address + ' ' + this.selectedStore.zip + ' ' + this.selectedStore.city
        },
        lastStepID () {
            return this.steps.length - 1
        },
        createdApp () { return this.$store.state.etermin.created },
        notifications () { return this.$store.state.notification.notifications },
        reservation () { return this.$store.getters['etermin/getReservation'] },
        ...mapState({
            steps: state => state.etermin.steps,
            customFields : state => state.etermin.customFields,
            reservation : state => state.etermin.reservation
        }),
        ...mapState([
            'selectedStore',
            'loading'
        ]),
        ...mapGetters('etermin', ['getActiveStep']),
        ...mapGetters('etermin', ['getTime']),
        ...mapGetters('etermin', ['getDate'])
    },
    methods: {
        formatDate : function(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-')
        },
        openModal: function (event) {
            event.preventDefault()
            this.$emit('openModal')
        },
        retry (event) {
            event.preventDefault()
            this.$store.dispatch('notification/clear', null, {
                root: true
            })
            this.appointement.date = null
            this.appointement.time = null
            if (this.getActiveStep === 0 || (this.getActiveStep - 1) === 0) {
                this.$store.dispatch('etermin/fetchServices', {store: this.selectedStore})
            }
            this.$store.dispatch('etermin/updateSteps', this.getActiveStep === 0 ? 0 : (this.getActiveStep - 1))
        },
        MoveNext (event) {
            event.preventDefault()
            let currentIndexActive = Number(this.getActiveStep)
            let nextActive = currentIndexActive + 1
            var status = 0
            switch (currentIndexActive) {
                case 0 : {
                    status = this.appointement.services.length > 0 ? 1 : -1
                    break
                }
                case 1 : {
                    status = this.appointement.time !== null ? 1 : -1
                    break
                }
            }
            this.$store.dispatch('etermin/validateStep', {index: currentIndexActive, status: status})
            if (status === 1) {
                this.$store.dispatch('etermin/updateSteps', nextActive)
            }
            this.$store.dispatch('notification/clear', null, {
                root: true
            })
        },
        MoveBack (event) {
            event.preventDefault()
            let previousActive = Number(this.getActiveStep) - 1
            this.$store.dispatch('etermin/updateSteps', previousActive)
            this.$store.dispatch('notification/clear', null, {
                root: true
            })
        },
        ManageAppointement (event) {

            event.preventDefault()

            let currentIndexActive = Number(this.getActiveStep)

            // Check form validation
            let status = 0
            this.$emit('validateRequired', 'firstname')
            this.$emit('validateRequired', 'lastname')
            this.$emit('validateMail', 'email')
            this.$emit('validateSalutation', 'salutation')
            this.$emit('validateTelephon', 'telephone')

            for (let field in this.fields) {
                if (!this.fields[ field ].validation) {
                    status = -1
                    this.$store.dispatch('etermin/validateStep', {index: currentIndexActive, status: status})
                }
            }
            if(status === 0){
                // Send to test/live depending on context
                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString)
                let testing = urlParams.get('testing')

                if (ServiceDrupal.getSettings().testing.status === 'enabled' || testing) {
                    this.appointement.calenderid = ServiceDrupal.getSettings().testing.calenderid
                }
                else{
                    this.appointement.calenderid = this.selectedStore.calenderid
                }

                let url = '/etermin/preconversion'
                // Google Tag-Manager push 'virtualPageView' to dataLayer
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: `virtual_page_view`,
                        event_type: ``,
                        event_data: {
                            path: url
                        }
                    })
                }

                if(this.reservation.id!==null){
                    this.createAppointement(this.reservation.id,this.reservation.secret);
                }
                else{
                    this.$store.dispatch('etermin/createReservation',
                        {
                            store: this.selectedStore,
                            calenderid: this.appointement.calenderid,
                            services: this.appointement.services.join(),
                            date: this.appointement.date,
                            time: this.appointement.time
                        })
                }
            }
        },
        createAppointement: function(reservation_id,secret){
            let fields =[];

            this.customFields.forEach(field => {
                if(field.translationKey=="customerFields.basic.email"){
                    fields.push({
                        id : field.id,
                        value : this.appointement.contact.email
                    })
                }
                if(field.translationKey=="customerFields.basic.firstName"){
                    fields.push({
                        id : field.id,
                        value : this.appointement.contact.firstname
                    })
                }
                if(field.translationKey=="customerFields.basic.lastName"){
                    fields.push({
                        id : field.id,
                        value : this.appointement.contact.lastname
                    })
                }
                if(field.translationKey=="customerFields.others.notes"){
                    fields.push({
                        id : field.id,
                        value : this.appointement.contact.description
                    })
                }
                if(field.translationKey=="customerFields.basic.mobilePhone"){
                    fields.push({
                        id : field.id,
                        value :"{\"number\":\""+this.appointement.contact.telephone+"\",\"country\":\"DE\"}"
                    })
                }
                if(field.translationKey=="customerFields.basic.salutation"){
                    fields.push({
                        id : field.id,
                        value : this.appointement.contact.salutation
                    })
                }
            })

            // Add notes field
            // Used staticly due the fact it will not change allover the branches
            // We need an extra request with authentification
            // We could use it and implemented on DatenStep.vue Component in mount function
            fields.push({
                id : '61f12d77b122151123ee1cf1', // Get it from branch manager customer/DataField and select the suitable field
                value : this.appointement.contact.description
            })

            let currentIndexActive = Number(this.getActiveStep)
            this.$store.dispatch('etermin/validateStep', {index: currentIndexActive, status: 1})
            this.$store.dispatch('notification/clear', null, {
                root: true
            })


            this.$store.dispatch('etermin/createAppointement', {
                'store': this.selectedStore,
                'calenderid': this.appointement.calenderid,
                'reservation_id': reservation_id,
                'secret': secret,
                'fields': fields
            })


        },
        closeApp: function () {
            this.$emit('closeApp')
        }
    }
}
</script>

<style lang="css">

</style>
